module.exports = __webpack_public_path__ + "static/img/diyim.249589b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/diyim.png
// module id = fxJv
// module chunks = 5